import events from 'src/analytics/eventNames';
import track from 'src/analytics/track';

export enum TreatsScreen {
  snapSticksDetailPage = 'Detail Page',
  planPage = 'Plan Page',
}

interface TrackAddedTreatsArgs {
  productName: string;
  size: string;
  quantity: number;
  viewScreen: TreatsScreen;
}

export function trackAddedTreats(addedTreatsInfo: TrackAddedTreatsArgs): void {
  track(events.treats_add_to_plan, { addedTreatsInfo });
}
